// VSB inside the plugin: tabs over one picture of the plugin. A strip tab
// swaps only its part of the picture (the FX module row); a whole tab shows a
// whole picture over it. Arrow keys, Home and End move between tabs (WAI-ARIA).
if (!customElements.get('d-screens')) {
  customElements.define(
    'd-screens',
    class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = this.tabs.map((t) => this.querySelector(`#${CSS.escape(t.getAttribute('aria-controls'))}`));
        this.layers = [...this.querySelectorAll('.d-screens__layer')];
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (e) => {
            const next = { ArrowRight: i + 1, ArrowDown: i + 1, ArrowLeft: i - 1, ArrowUp: i - 1, Home: 0, End: this.tabs.length - 1 }[e.key];
            if (next === undefined) return;
            e.preventDefault();
            this.select((next + this.tabs.length) % this.tabs.length, true);
          });
        });
        // Theme editor: selecting a screen's block shows it.
        document.addEventListener('shopify:block:select', (e) => {
          const i = this.tabs.findIndex((t) => t.dataset.shopifyEditorBlock?.includes(e.detail.blockId));
          if (i >= 0) this.select(i);
        });
      }

      select(index, focus = false) {
        if (index === this.current) return;
        this.current = index;
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute('aria-selected', String(on));
          tab.tabIndex = on ? 0 : -1;
          if (this.panels[i]) this.panels[i].hidden = !on;
        });
        this.layers.forEach((layer) => {
          const on = Number(layer.dataset.for) === index;
          layer.hidden = !on;
          // Replay the swap's flash on the part that changed.
          if (on) {
            layer.classList.remove('is-new');
            void layer.offsetWidth;
            layer.classList.add('is-new');
          }
        });
        const tab = this.tabs[index];
        if (focus) tab.focus();
        tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }
  );
}
